<template>
    <div class="app-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in breadList"
                                :key="index"
                                :to="item.path">
                {{ item.label }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

</template>

<script>
export default {
    name: 'Breadcrumb',
    props: {
        breadList: {
            type: Array,
            default () {
                return []
            }
        }
    }
}
</script>

<style lang="scss">
.el-breadcrumb {
    display: inline-block;
    background: transparent;
    border-radius: 4px;
    padding: 9px 20px 9px 0;
    line-height: 17px;
    font-size: 12px !important;
    vertical-align: middle;
    .el-breadcrumb__item {
        line-height: 12px;
    }
    .el-breadcrumb__separator {
        color: #999;
    }
    .el-breadcrumb__inner {
        color: #999;
        line-height: 12px;
        &.is-link,
        a {
            color: #999;
            font-weight: normal;

            &:hover {
                color: $color-primary;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.app-breadcrumb {
    background-color: #fff;
    padding-left: 10px;
    box-shadow: 0 1px 0 0 rgba(203, 203, 203, 0.5);
}
</style>
